<template>
  <div id="app">
    <v-ons-splitter>
      <v-ons-splitter-side width="342px" collapse="" side="right" :open.sync="isOpen" id="splitter_side_menu" :class="{open: isOpen}">
        <v-ons-page>
          <div class="p-h-menu">
            <div class="p-h-menu__nav">
              <a class="p-h-menu__nav-item" :href="atmTopUrl"><img src="./assets/images/side/icon-office_atm.svg" style="opacity: 1;">店舗・ATM</a>
              <a class="p-h-menu__nav-item" href="https://www2.ncbank.co.jp/request_brochure/?_gl=1*11cb2tu*_gcl_aw*R0NMLjE2MTA1ODU1MzMuQ2owS0NRaUEwZnJfQlJEYUFSSXNBQUJ3NEV2Sk41eEIyaDdrd3k2a2pVWGNBZFpObHA1SjZLWjk4RWkxNUpqOGVIVk9EMmFfekdSOEp0d2FBalNPRUFMd193Y0I.&_ga=2.95795999.2036042818.1612140614-1822495815.1611814134&_gac=1.184586843.1610585532.Cj0KCQiA0fr_BRDaARIsAABw4EvJN5xB2h7kwy6kjUXcAdZNlp5J6KZ98Ei15Jj8eHVOD2a_zGR8JtwaAjSOEALw_wcB"><img src="./assets/images/side/icon-procedures.svg">資料請求</a>
              <a class="p-h-menu__nav-item" href="https://www.ncbank.co.jp/otoiawase/"><img src="./assets/images/side/icon-contact.svg">お問い合わせ</a>
              <a class="p-h-menu__nav-item modalwbtn" @click="showWebServiceBooks()"><img src="./assets/images/side/icon-denpyou.svg">WEB帳票作成</a>
              <a class="p-h-menu__nav-item" href="https://www.ncbank.co.jp/kinri_tesuryo/kawase/"><img src="./assets/images/side/icon-mainfee.svg">主要手数料一覧</a>
              <a class="p-h-menu__nav-item" href="https://www2.ncbank.co.jp/interest.php"><img src="./assets/images/side/icon-exchangerate.svg">金利・為替相場</a>
            </div><!-- /.p-h-menu__nav -->
            <div class="p-h-menu__search">
              <form name="search_form" action="https://sitesearch.ncbank.co.jp/" method="GET" onsubmit="mysearch(this);">
                <input type="text" name="kw" value="" class="iSearchAssist" placeholder="サイト内検索" autocomplete="off">
                <input type="hidden" name="ie" value="u">
                <button type="submit">検索</button>
              </form>
            </div>
            <ul class="p-h-menu__main">
              <li class="p-h-menu__main-item current"><a href="https://www.ncbank.co.jp/">個人のお客さま</a></li>
              <li class="p-h-menu__main-item "><a href="https://www.ncbank.co.jp/hojin/">法人・個人事業主のお客さま</a></li>
              <li class="p-h-menu__main-item "><a href="https://www.ncbank.co.jp/corporate/">西日本シティ銀行について</a></li>
              <li class="p-h-menu__main-item "><a href="https://www.ncbank.co.jp/saiyo_joho/?_gl=1*18suyny*_gcl_aw*R0NMLjE2MTE1MzYzNzkuQ2owS0NRaUEwclNBQmhEbEFSSXNBSnRqZkNmbDc5YnFMdkNibTRLMDNCODVsX2ZRYzlVSUpBLXpNYllHNlU3YmlSM0RxNVZ6NzNJYlk3TWFBbUVrRUFMd193Y0I.&_ga=2.32949239.814046079.1611536368-1384539511.1608796340&_gac=1.61849054.1611536379.Cj0KCQiA0rSABhDlARIsAJtjfCfl79bqLvCbm4K03B85l_fQc9UIJA-zMbYG6U7biR3Dq5Vz73IbY7MaAmEkEALw_wcB/">採用情報</a></li>
            </ul><!-- /.p-h-menu__main -->
            <div class="p-h-menu__sub">
              <a class="p-h-menu__sub-item" href="https://www.ncbank.co.jp/sitemap/">サイトマップ</a>
              <a class="p-h-menu__sub-item" href="https://www.ncbank.co.jp/kabunushi_toshika/annual_report/">English</a>
            </div><!-- /.p-h-menu__sub -->
            <button class="p-h-menu__close" @click="hideSideMenu()">閉じる</button>
          </div>
          <v-ons-dialog :visible.sync="visibleServiceBooks" id="sp_serviceBooks" animation="none" cancelable>
            <div class="service_book_wrapper">
              <p>ご利用するサービスを選択ください。</p>
              <div class="service_book_buttons">
                <a href="https://www.ncbank.co.jp/service/denpyousakuseiweb/" v-ripple><span>伝票作成WEBサービス</span></a>
                <a href="https://www.ncbank.co.jp/hojin/efficiency/henkoutodoke_sakuseiweb/" v-ripple><span>法人・団体用 変更届作成WEBサービス</span></a>
              </div>
            </div>
          </v-ons-dialog>
        </v-ons-page>
      </v-ons-splitter-side>

      <v-ons-splitter-content>
        <keep-alive>
          <v-ons-navigator id="myNavigator" swipeable :page-stack="pageStack" :pop-page="goBack" @show-modal="handleModal($event)"></v-ons-navigator>
        </keep-alive>

        <v-ons-dialog :visible.sync="visibleGrepFilter" id="grepFilterModal">
          <GrepFilter></GrepFilter>
        </v-ons-dialog>

        <v-ons-dialog :visible.sync="visibleSelectArea" id="grepAreaModal">
          <SelectArea></SelectArea>
        </v-ons-dialog>
      </v-ons-splitter-content>
    </v-ons-splitter>
  </div>
</template>
<script>
import store from './store/store';
import ApiService from './services/api-service.js';
import ConfigService from './services/config-service.js';

import GrepFilter from './components/GrepFilter.vue';
import SelectArea from './components/SelectArea.vue';

import _ from 'lodash';

export default {
  name: 'App',
  components: {
    GrepFilter,
    SelectArea
  },
  data() {
    return {
      // isOpen: false,
      // pageStack: []
      visibleServiceBooks: false,
      atmTopUrl: `${location.origin}/atm/`,
    };
  },
  computed: {
    // ページスタックを返却します。
    pageStack: {
      get() {
        return store.state.navigator.stack;
      },
      set(newVal) {
        store.state.navigator.stack = newVal;
      }
    },
    // オプションを返却します。
    options  : function() {
      return store.state.navigator.options;
    },
    isOpen: function() {
      return store.state.showMenu;
    },
    visibleSelectArea: function() {
      return store.state.showSelectArea;
    },
    visibleGrepFilter: function() {
      return store.state.showGrepFilter;
    },
    isMobile: function() {
      return store.state.isMobile;
    }
  },
  watch: {
    isMobile(newVal, oldVal) {
      if (!newVal) {
        this.visibleServiceBooks = false;
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push({name: this.$route.matched[this.$route.matched.length - 2].name});
    },
    /**
     * WEB帳簿作成ダイアログを表示します
     */
    showWebServiceBooks() {
      this.visibleServiceBooks = true;
    },
    /**
     * サイドメニューを閉じます
     */
    hideSideMenu() {
      store.dispatch('updateShowMenu', false);
    },
    /**
     * サイト内検索をサブミットします（移植）
     */
    mysearch(obj) {
      let ActionProtcol;
      if (obj.action.indexOf('https:') === 0) {
        ActionProtcol = 'https://';
      } else {
        ActionProtcol = 'http://';
      }

      const url = ActionProtcol + 'sitesearch.ncbank.co.jp/?ref=' + this.URLencode(location.href) + '&kw=' + this.URLencode(obj.kw.value) + '&ie=' + obj.ie.value + '&by=js';
      document.location.href = url;
      return false;
    },
    /**
     * URLをエンコードします（移植）
     */
    URLencode(str) {
      let i;
      let encoded_str;
      let char_code;
      let padded_str;
      encoded_str = "";

      for (i = 0; i < str.length; i++) {
        char_code = str.charCodeAt(i);
        if (char_code == 0x20){
          encoded_str += "+";
        } else {
          if (((0x30 <= char_code) && (char_code <= 0x39)) || ((0x41 <= char_code) && (char_code <= 0x5a)) || ((0x61 <= char_code) && (char_code <= 0x7a))) {
            encoded_str += str.charAt(i);
          } else if ((char_code == 0x2a) || (char_code == 0x2e) || (char_code == 0x2d) || (char_code == 0x5f)) {
            encoded_str += str.charAt(i);
          } else {
            if ( char_code > 0xffff ) {
              encoded_str += "%" + ((char_code >> 18) | 0xf0).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 12) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 6) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else if ( char_code > 0x7ff ) {
              encoded_str += "%" + ((char_code >> 12) | 0xe0).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 6) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else if ( char_code > 0x7f ) {
              encoded_str += "%" + (((char_code >> 6) & 0x1f) | 0xc0).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else {
              padded_str = "0" + char_code.toString(16).toUpperCase();
              encoded_str += "%" + padded_str.substr(padded_str.length - 2, 2);
            }
          }
        }
      }

      return encoded_str;
    },
  },
  async created() {
    const mapRouteStack = route => {
      const animation = route.params.animation || 'slide';
      return this.pageStack = route.matched.map(m => {
        if (this.isMobile) {
          m.components.default.onsNavigatorOptions.animation = animation;
        } else {
          m.components.default.onsNavigatorOptions.animation = 'none';
        }
        return m.components.default
      });
    }
    mapRouteStack(this.$route);

    this.$router.beforeEach((to, from, next) => {
      mapRouteStack(to) && next()
    });

    // if (this.$ons.platform.isIPhoneX()) { 
    //   document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
    // }
    let overlay = this.$loading.show({
      // canCancel: true,
      color: '#000000',
      loader: 'spinner',
      width: 32,
      height: 32,
      backgroundColor: '#000000',
      opacity: 0.2,
      zIndex: 999
    });
    await ApiService.conditionsSearch()
      .then(data => {
        console.log(data);
        const excels = {
          'date': data.excel_date,
          'url': data.excel_url
        }
        store.dispatch('updateAllStores', data.info);
        store.dispatch('updateExcel', excels);
        store.dispatch('updateHoliday', data.holiday);
        overlay.hide();
        return;
      }, error => {
        console.log(error);
        overlay.hide();
      });

  },
  mounted: function() {
    console.log(`>>> ${ConfigService.getCurrentEnv()}`);
    const splitterSideMenu = document.getElementById('splitter_side_menu');
    splitterSideMenu.addEventListener('preclose', () => {
      store.dispatch('updateShowMenu', false);
    });

    window.addEventListener('resize', _.debounce((event) => {
      this.$nextTick(() => {
        const width = window.innerWidth;

        if (width <= 813) {
          store.dispatch('updateIsMobile', true);
        } else {
          store.dispatch('updateIsMobile', false);
          store.dispatch('updateShowMenu', false);
        }
      });
    }), 300);

    // window.addEventListener('beforeunload', () => {
    //   localStorage.removeItem('ncbAtm.result');
    //   localStorage.removeItem('ncbAtm.type');
    // });
  },
  destroyed: function() {
    localStorage.removeItem('ncbAtm.result');
    localStorage.removeItem('ncbAtm.type');
  }
}
</script>
<style lang="scss">
@import "assets/styles/splitter_side.scss"; // SPサイドメニュー
@import "assets/styles/styles.scss";
</style>
